export default __webpack_public_path__ + "static/skeena.227b1f0c13f3cbdb5e48a2d79d831f57.png";